import { render } from "./zhengcDetail.vue?vue&type=template&id=7115e456&scoped=true"
import script from "./zhengcDetail.vue?vue&type=script&lang=js"
export * from "./zhengcDetail.vue?vue&type=script&lang=js"

import "./zhengcDetail.vue?vue&type=style&index=0&id=7115e456&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7115e456"]])

export default __exports__